import {
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlCloseFeedbackIcon } from '../TrlCloseFeedbackIcon';
import {
  CircleIconStyled,
  MessageContainer,
  MessageStyled,
  MessageTitleStyled,
  TrlFeedbackStyled,
} from './TrlFeedback.styled';

export const TrlFeedback = ({ title, msg, success, onClose }) => {
  const [showFeedback, setShowFeedback] = useState(true);

  const handleClose = useCallback(() => {
    setShowFeedback(false);
    if (onClose) onClose();
  }, [onClose]);

  useEffect(() => {
    const timer = setTimeout(handleClose, 4000);

    return () => clearTimeout(timer);
  }, [handleClose]);

  const regex = /TRLT_UI-[A-Z0-9_]+/g;

  const renderMessage = () => {
    const msgSegments = [];

    msg.split(regex).forEach((part, index) => {
      if (index > 0) {
        const matchedKey = msg.match(regex)[index - 1];
        msgSegments.push(
          <FormattedMessage
            key={matchedKey}
            id={matchedKey}
            defaultMessage={matchedKey}
          />,
        );
      }

      msgSegments.push(part);
    });

    return msgSegments;
  };

  if (!showFeedback) return null;

  return (
    <TrlFeedbackStyled id="divFeedback" success={success}>
      <CircleIconStyled
        icon={success ? faCircleCheck : faCircleExclamation}
        success={success}
      />
      <MessageContainer>
        {title && (
          <MessageTitleStyled>
            <FormattedMessage id={title} />
          </MessageTitleStyled>
        )}
        <MessageStyled>{renderMessage()}</MessageStyled>
      </MessageContainer>
      <TrlCloseFeedbackIcon onClick={handleClose} />
    </TrlFeedbackStyled>
  );
};

TrlFeedback.propTypes = {
  title: PropTypes.string,
  msg: PropTypes.string.isRequired,
  success: PropTypes.bool,
  onClose: PropTypes.func,
};
